module.exports = __webpack_public_path__ + "static/media/level-up.36e6d427.svg";